var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["FINE"] = 0] = "FINE";
  LogLevel2[LogLevel2["DEBUG"] = 1] = "DEBUG";
  LogLevel2[LogLevel2["INFO"] = 2] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 3] = "WARN";
  LogLevel2[LogLevel2["SEVERE"] = 4] = "SEVERE";
  LogLevel2[LogLevel2["NONE"] = 5] = "NONE";
  return LogLevel2;
})(LogLevel || {});
export {
  LogLevel
};
